import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid
} from "@chakra-ui/react";
import FormFinanceProject from "./components/Form";
import FinanceProjectTable from "./components/Table";
import useFinanceProject from "./hooks/useFinanceProject";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const FinanceProjectScreen = () => {
  const {
    list1,
    selectedOrder1,
    show1,
    showModal1,
    loading,
    save,
    changeItem,
    changeProject,
    error,
    errorMsg,
    errorTitle,
    cancelRef,
    closeError,
    approve,
    loadingApprove,
    showApprove,
    showModalApprove,
    cancelModalApprove,
    cancelRascunho,
  } = useFinanceProject();


  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} overflowY={"scroll"}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show1,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal1(false, null)}
                title=" Conciliação Financeira do Projeto"
              >
                <FormFinanceProject
                  accountSelected={selectedOrder1}
                  loading={loading}
                  save={save}
                  show={show1}
                  showModal={showModal1}
                  changeItem={changeItem}
                  changeProject={changeProject}
                  showModalApprove={showModalApprove}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <FinanceProjectTable list={list1} showModal={showModal1} />
          </SimpleGrid>
        )}
      />

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isOpen={showApprove}
        leastDestructiveRef={cancelRascunho}
        onClose={cancelModalApprove}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Deseja Aprovar a Conciliação financeira?
            </AlertDialogHeader>

            <AlertDialogBody>
              Aprovando a conciliação financeira, tanto as tarefas como o a gestão do projeto poderão ser executadas.
              da forma que preferir.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={cancelModalApprove}
                colorScheme={"red"}
                mr={4}
              >
                Cancelar
              </Button>

              <Button
                onClick={approve}
                colorScheme={"blue"}
                isLoading={loadingApprove}
              >
                Salvar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default FinanceProjectScreen;
